import { getErrorMessages, useGetLiabilityQuery } from "../../../../services";
import { LiabilitiesDetails } from "../../types";
import { UseLiabilityDataReturn } from "./types";

export const useLiabilityData = (id: number): UseLiabilityDataReturn => {
  const {
    data,
    error: queryError,
    isLoading,
    isFetching,
    refetch,
  } = useGetLiabilityQuery(id);

  const liability = data ?? ({} as LiabilitiesDetails);

  const errorMessages = queryError ? getErrorMessages(queryError as any) : [];
  const error = errorMessages[0] ?? null;

  return {
    liability,
    isLoading: isLoading || (isFetching && !data),
    error,
    notFoundError: error === "Liability not found",
    lastPaymentDate: data?.lastPaymentDate ?? null,
    refetch: async () => {
      await refetch();
    },
  };
};
